import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { concatNames } from 'functions/contact'
import coverImageUrl from 'agency/digital_renderer/utils/coverImageUrl'

import Button from 'components/Button'
import BrandLogo from 'components/BrandLogo'

import ContentHolder from '../../ui/ContentHolder'
import headerImage from '../../assets/header-default.jpg'
import styles from './styles.scss'

const DownloadButton = ({ artwork }) => {
  if (artwork && artwork.links){
    return (
      <Button
        color="darkGrey"
        icon={<FontAwesomeIcon icon={faDownload} />}
        href={artwork.links.download_url}
        text="Download"
      />
    )
  }

  return null
}

DownloadButton.propTypes = {
  artwork: PropTypes.object.isRequired,
}

const Header = (props) => {
  const {
    artwork,
    brand,
    campaign: { address, suburb_name },
    campaignProposal,
    contacts,
    images,
  } = props

  const contactCount = Object.keys(contacts).length

  return (
    <header
      className={styles.root}
      style={{ backgroundImage: `url(${coverImageUrl(campaignProposal.options, images, headerImage)})` }}
    >
      <div className={styles.topBar}>
        <ContentHolder fullWidth row style={{ alignItems: 'center' }}>
          <BrandLogo
            brand={brand}
            type="mono_logo"
            render={({ url }) => <span className={styles.logo} style={{ backgroundImage: `url(${url})` }} />}
          />

          <div className={styles.actions}>
            <DownloadButton artwork={artwork} />
          </div>
        </ContentHolder>
      </div>

      <ContentHolder className={styles.content}>
        <Fade bottom>
          <span className={styles.address}>
            {address},<br />
            {suburb_name}
          </span>
        </Fade>

        {contactCount <= 2 && (
          <span className={styles.preparedFor}>
            <span className={styles.label}>Prepared For:</span>
            <span className={styles.title}>{concatNames(contacts)}</span>
          </span>
        )}
      </ContentHolder>
    </header>
  )
}

Header.propTypes = {
  artwork: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  images: PropTypes.object.isRequired,
}

export default Header
